<template>
  <tr class="row" loading v-if="!item">
    <slot>
      <td class="typo-regular text-light-low col-2 col-mlg-3 text-left">
        <p class="skeleton skeleton-light w200 h19"></p>
        <p class="skeleton skeleton-light w100 h15 mt-1"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w50 h17"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td>
      <!-- <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td>
      <td class="typo-regular text-light-low col">
        <p class="skeleton skeleton-light w25 h17"></p>
        <p class="skeleton skeleton-light w50 h15 mt-1"></p>
      </td> -->
    </slot>
  </tr>
  <tr class="row" v-else>
    <slot :item="item" :lastModified="lastModified" :pageType="pageType" v-if="!hasBody">
      <td class="col-2 col-mlg-3 text-left">
        <p class="typo-heading16 typo-medium text-light-high ellipsis">{{ item.g_title }}</p>
        <p class="typo-paragraph12 typo-regular mt-1">
          <span></span>
          <span>{{ $t("generals.lastModified")}} {{ lastModified }}</span>
        </p>
      </td>
      <td class="col">
        <p class="typo-">{{ parseInt((item.percent || 0) * 100) }}%</p>
      </td>
      <td class="col">
        <p class="typo-">{{ item.report.unique_visitors.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.unique_visitors.avg != undefined">Avg.: {{ item.report.unique_visitors.avg }}</p>
      </td>
      <td class="col">
        <p class="typo-">{{ item.report.sessions.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.sessions.avg != undefined">Avg.: {{ item.report.sessions.avg }}</p>
      </td>
      <td class="col">
        <p class="typo-">{{ item.report.views.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.views.avg != undefined">Avg.: {{ item.report.views.avg }}</p>
      </td>
      <td class="col">
        <p class="typo-">{{ item.report.add_to_cart.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.add_to_cart.avg != undefined">Avg.: {{ item.report.add_to_cart.avg }}</p>
      </td>
      <td class="col">
        <p class="typo-">{{ item.report.add_to_cart_rate.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.add_to_cart_rate.avg != undefined">Avg.: {{ item.report.add_to_cart_rate.avg }}</p>
      </td>
      <!-- <td class="col">
        <p class="typo-">{{ item.report.conversion.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.conversion.avg != undefined">Avg.: {{ item.report.conversion.avg }}</p>
      </td>
      <td class="col">
        <p class="typo-">{{ item.report.conversion_rate.today }}</p>
        <p class="typo-paragraph12 text-light-low mt-1" v-if="item.report.conversion_rate.avg != undefined">Avg.: {{ item.report.conversion_rate.avg }}</p>
      </td> -->
    </slot>
    <slot :item="item" :lastModified="lastModified" :pageType="pageType" v-else />
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';
import TimeMaker from "@/plugins/timemaker";
export default {
  name: "PageReportItem",
  props: {
    item: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    hasBody() {
      return !!this.$slots["default"] || !!this.$scopedSlots["default"];
    },
    lastModified() {
      return new TimeMaker(this.item.updated_at).ago(this.language);
    },
    pageType() {
      switch (this.item.g_type) {
        case "template-page":
          return this.$t("page.landingPages1");
        case "template-article":
          return this.$t("dashboard.articlePage");
        case "template-index":
          return this.$t("dashboard.homePage");
        case "template-product":
          return this.$t("dashboard.productPage");
        case "template-collection":
          return this.$t("dashboard.collectionPage");
        default:
          return false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.w {
  &402 {
    width: 402px;
  }
  &250 {
    width: 250px;
  }
  &220 {
    width: 220px;
  }
  &200 {
    width: 200px;
  }
  &125 {
    width: 125px;
  }
  &100 {
    width: 100px;
  }
  &56 {
    width: 56px;
  }
  &50 {
    width: 50px;
  }
  &25 {
    width: 25px;
  }
  &13 {
    width: 13px;
  }
}
.h {
  &19 {
    height: 19px;
  }
  &17 {
    height: 17px;
  }
  &16 {
    height: 16px;
  }
  &15 {
    height: 15px;
  }
  &14 {
    height: 14px;
  }
}
td {
  border: 1px solid $light3;
  background: $light1;
  padding: 20px;
  border-collapse: collapse;

  &:not(.text-left) {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.event-skeleton {
  height: 80px;
  border: solid 1px $light3;
  border-radius: 3px;
  td {
    border: none!important;
    &.event-skeleton__left {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &.event-skeleton__right {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    .event-skeleton__border {
      border-radius: 3px;
    }
  }

}
</style>
